export function filterBrand(brandCode: number): void {
  const url = new URL(window.location.href);

  const marcas = JSON.parse(url.searchParams.get("marcaCodes") || "[]");
  const index = marcas.indexOf(brandCode);

  if (index === -1) {
    marcas.push(brandCode);
  } else {
    marcas.splice(index, 1);
  }

  if (marcas.length === 0) {
    url.searchParams.delete("marcaCodes");
  } else {
    url.searchParams.set("marcaCodes", JSON.stringify(marcas));
    url.pathname = "/productos";
  }

  window.location.href = url.toString();
}
